import {Component, Input, OnDestroy, OnInit} from '@angular/core';
// import {TranslateService} from '@ngx-translate/core';
import {AnnouncementService} from '../../../views/common/dialog-announcement/announcement.service';
import {ThemeService} from '@app/core/service/theme.service';
import {takeWhile} from 'rxjs/operators';

@Component({
    selector   : 'ngc-footer-page',
    templateUrl: './footer-page.component.html',
    styleUrls  : ['./footer-page.component.scss']
})
export class FooterPageComponent implements OnInit, OnDestroy {

    currentYear: number = new Date().getFullYear();
    @Input() textColor = 'black';
    selectedLanguage: any;
    languages: any;
    footerData: any;
    readonly defaultCompanyLink = {
        title: 'SchoolDay, Inc.',
        url: 'mailto:info@GG4L.com',
        target: '_blank'
    };

    private alive = true;

    constructor(
        // private translate: TranslateService,
        private announcementService: AnnouncementService,
        private themService: ThemeService
    ) {
        this.languages = [
            {
                'id'   : 'en',
                'title': 'English',
                'flag' : 'us'
            },
            {
                'id'   : 'tr',
                'title': 'Turkish',
                'flag' : 'tr'
            }
        ];
    }

    ngOnInit() {
        const locale = JSON.parse(localStorage.getItem('locale'));
        this.selectedLanguage = locale || this.languages[0];
        // this.translate.use(this.selectedLanguage.id);

        this.themService.getBundle().pipe(
            takeWhile(() => this.alive),
        ).subscribe(bundle => {
            this.footerData = (bundle && bundle['footer'] ? bundle['footer'] : null);
        });
    }

    setLanguage(lang) {
        this.selectedLanguage = lang;
        localStorage.setItem('locale', JSON.stringify(lang));

        // Use the selected language for translations
        // this.translate.use(lang.id);
    }

    showPrivacyPolicy() {
        this.announcementService.getPrivacyPolicyForFooter();
    }

    showTermsOfUse() {
        this.announcementService.getTermsOfUseForFooter();
    }

    public ngOnDestroy() {
        this.alive = false;
    }
}
